import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, assertUnreachable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { InfoEntregaComp } from "./info";
import { Observable } from "rxjs";
import { ListGuiasEntrega } from "./list";
import { PagoEntrega } from "./pago";
import { puedeFinalizar, onFinalizarEntrega } from "./logic";
import { FinalizarEntregaEdit, RecordarAcusesModal } from "./finalizar";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import * as L from "leaflet";
import { GuiaList } from "app/features/general/operativa/items/resumenchoferze/list/componentes/guias/list";

interface propsSelector {
    items: models.ContactoClienteDTO[];
    value: number;
    onChange: (value: number) => PromiseLike<void> | void;
    soloAutorizados: boolean;
    readonly?: boolean;
}

function getIcon(color: "orange" | "grey" | "blue") {
    return new L.Icon({
        iconUrl: 'app/img/' + color + '.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });
}

const iconos = {
    naranja: getIcon("orange"),
    gris: getIcon("grey"),
    azul: getIcon("blue")
};

class ContactoSelectorNoRX extends React.PureComponent<propsSelector> {

    value = (x: propsSelector) => x.value;
    readonly = (x: propsSelector) => x.readonly;
    contactos = (x: propsSelector) => x.items;
    soloAutorizados = (x: propsSelector) => x.soloAutorizados;
    items = createSelectorRx(this.contactos, this.soloAutorizados, (contactos, soloAutorizados) => soloAutorizados ? contactos.filter(x => x.AutorizadoRecibir) : contactos);

    render() {
        const items = this.items(this.props);
        const value = this.value(this.props);
        const readonly = this.readonly(this.props);

        return <kea.Select
            label="Contacto recibió"
            items={items.map(x => ({ label: x.Nombre, value: x.IdRegistro }))}
            value={value}
            onChange={this.props.onChange}
            readonly={readonly}
        />
    }
}
export const ContactoSelector = componentToRx(ContactoSelectorNoRX);

type Entity = models.EntregaZERealizadaDTO;
export interface Props {
    value: Entity;
    informacion: models.InfoEntregaZE;
    onChange: (value: Entity) => PromiseLike<void> | void;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Valida un EntregaZERealizada
*/
export function validar(x: Entity) {

    const validarGuias = (value: Entity) =>
        x.GuiasNoEntregadas.length + x.GuiasEntregadas.length != x.Guias.length ? false : true;

    const rules: validation.Rules<Entity> = {
        NombreContactoRecibio: x => x.IdContactoRecibio ? true : !!x.NombreContactoRecibio,
        Guias: validarGuias
    };
    return validation.getErrors(rules, x);
}

const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar", iconClass: fa("check"), style: "success" });
/**
* Componente para editar un Entity
*/
export class EntregaZERealizadaFormNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();
    value = (props: Props) => props.value;
    idDestino = (props: Props) => props.value.IdDireccionDestino;
    nuevo = (props: Props) => props.nuevo;


    destino = createSelectorRx(this.idDestino, idDestino => observeResource(resources.Cliente.GetDireccion, idDestino));
    idCliente = createSelectorRx(this.destino, destino => destino.IdCliente);
    cliente = createSelectorRx(this.idCliente, idCliente => observeResource(resources.Cliente.ConsultarDatosCredito, idCliente));
    SoloRecibirContactosAutorizado = createSelectorRx(this.destino, destino => destino.Cliente.SoloRecibirContactosAutorizado);

    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    contactosDireccion = createSelectorRx(this.idDestino, id => id ? observeResource(resources.Cliente.ConsultarContactos, id) :
     Observable.from([[]]));

    Guias = (id: number) => observeResource(resources.EntregaZERealizada.GetGuias,id);

    informacionEntrega = (props: Props) => props.informacion;


    onRegresar = () => {
        window.history.back()
    }

    onModificado = async (x: Entity) => {
        const nuevo = this.nuevo(this.props);
        if (nuevo) {
            await this.props.onChange(x)
        }
    }

    onFinalizar = async () => {
        const saldoObv = this.cliente(this.props);
        const cliente = await nextToPromise(saldoObv);

        const validacion = puedeFinalizar(this.props.value, cliente);
        if (validacion != true) {
            switch (validacion) {
                case "faltaContacto":
                    await kea.message("Contacto", "El contacto es obligatorio", "error");
                    break;
                case "faltaMotivo":
                    await kea.message("Motivo de rechazo", "Alguna guia rechazada no tiene el motivo especificado", "error");
                    break;
                case "saldoInsuficiente":
                    await kea.message("Saldo insuficiente", "El cliente no tiene suficiente saldo para pagar la entrega a crédito", "error");
                    break;
                case "creditoBloqueado":
                    await kea.message("Linea de crédito bloqueada", "El cliente tiene su linea de crédito bloqueada", "error");
                    break;
                case "sinGuias":
                    await kea.message("Sin guias", "Seleccione por lo menos una guia para entregar/rechazar", "error");
                    break;
                default: assertUnreachable(validacion);
            }
            return;
        }

        const info = this.informacionEntrega(this.props);
        //Si la entrega esta finalizada, esta ya es de solo lectura
        if (info.Finalizado) {
            await kea.message("Entrega finalizada", "La entrega ya esta finalizada", "warning");
            return;
        }

        //Recordar al usuario de los acuses
        if (info.AcusesEntregar.length > 0) {
            const ok = await this.modalManager.showModal(RecordarAcusesModal, info.AcusesEntregar, undefined);
            if (!ok.result) return;
        }

        // //Pedir la firma del cliente
        const result = await this.modalManager.showModal(FinalizarEntregaEdit, undefined, { Segmentos: [] } as models.FirmaModel);

        if (result.result) {
            const next = await onFinalizarEntrega(this.props.value, result.value);
            await this.props.onChange(next);
            await this.props.onGuardar();
            await kea.message("Entrega finalizada", "Esta entrega de zona extendida ha sido finalizada", "success");
            history.go("../");
        }
    }

    render() {
        const { value, onGuardar } = this.props;
        const getField = this.getField;

        const hasError = this.hasError(this.props);
        const idDestino = this.idDestino(this.props);
        const idCliente = this.idCliente(this.props);
        const nuevo = this.nuevo(this.props);
        this.props.value.IdRegistro
        const informacionEntrega = this.informacionEntrega(this.props);

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Contacto = getField(ContactoSelector);
        const Guias = getField(ListGuiasEntrega);

        const ListGuias = this.Guias(this.props.value.IdRegistro)



        return (
            <div>
                {
                    value != null ?
                        (() => {
                            const contactos = this.contactosDireccion(this.props);
                            const SoloRecibirContactosAutorizado = this.SoloRecibirContactosAutorizado(this.props);
                            
                            return (
                                <div>
                                    <kea.Title titulo="Entrega realizada" onRegresar={this.onRegresar} >
                                        {
                                            nuevo &&
                                            <FinalizarButton onClick={this.onFinalizar} disabled={hasError} />
                                        }
                                    </kea.Title>
                                    <InfoEntregaComp value={informacionEntrega} />
                                    <Contacto
                                        field="IdContactoRecibio"
                                        items={contactos}
                                        soloAutorizados={SoloRecibirContactosAutorizado}
                                        readonly={!nuevo}
                                    />
                                    {
                                        value.IdContactoRecibio == null &&
                                        <Text field="NombreContactoRecibio" label="Nombre nuevo contacto recibió" />
                                    }
                                    {nuevo && <PagoEntrega {...this.props} idCliente={idCliente} onChange={this.onModificado} />}
                                    
                                    { nuevo && <ListGuiasEntrega {...this.props} onChange={this.onModificado} />}
                                    { !nuevo && <GuiaList value={ListGuias} /> }
                                </div>
                            )
                        })()
                        :
                        <div className="alert alert-warning">
                            <label>Esta entrega ya no existe</label>
                        </div>
                }
                {this.modalManager.component}
            </div>);
    }
}

export const EntregaZERealizadaForm = componentToRx(EntregaZERealizadaFormNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entrega/formn.tsx